import { TextView } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { receptionServiceTranslationKeys } from '../../../../../translations';

export const ReceptionServiceFreeText = (): JSX.Element => {
   return (
      <TextView testId={'freeText'} label={receptionServiceTranslationKeys.shared.form.components.freeText.label}>
         <Translate>{receptionServiceTranslationKeys.shared.form.components.freeText.text}</Translate>
      </TextView>
   );
};
